module.exports = __webpack_public_path__ + "static/media/logo.d586c2b3.svg";